import { Box, Button, Paper, Tooltip, Typography } from "@mui/material";
import { exportClientsReport, exportEmployeeAttendanceReport, exportEmployeeLogHoursReport } from "api/services/reports";
import Loader from "components/Loader";
import Table from "components/Table";
import { snack } from "components/toast";
import moment from "moment";
import { useMutation } from "react-query";
import { getCurrentFormattedDateTime, getTitle } from "utils";
import { handleError } from "utils/handleError";
import excelIcon from "./../../../assets/images/128px-Microsoft_Office_Excel_(2019–2025).svg.png";


function Report({ data, state, isLoading, isError }) {
    const { mutate, isLoading: isExporting } = useMutation(exportEmployeeAttendanceReport, {
        onSuccess: (res: any) => {
            const arr = new Uint8Array(res.data?.data);
            const blob = new Blob([arr], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const file = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            const formattedDateTime = getCurrentFormattedDateTime();
            link.href = file;
            link.download = `ATOM - Employee Attendance Report ${formattedDateTime}.xlsx`;
            link.click();
            snack.success("Report Exported to Excel");
        },
        onError: (err: any) => {
            snack.error(handleError(err));
        },
    });

    const handleExport = () => {
        if (isExporting) return;
        mutate({
            ...state,
            fromDate: state.fromDate ? moment(state.fromDate).format("YYYY-MM-DD") : null,
            toDate: state.toDate ? moment(state.toDate).format("YYYY-MM-DD") : null,
        });
    };

    if (isLoading) return <Loader />;

    if (isError) return null;

    if (!data) return null;

    return (
        <Paper sx={{ mt: 2, p: 2 }}>
            <Box display="flex" justifyContent="space-between" mb={2} alignItems="center">
                <Box>
                </Box>
                <Box>
                    <Tooltip title={isExporting ? "Exporting..." : "Data Export to Excel"}>
                        <img
                            src={excelIcon}
                            alt="Export"
                            style={{
                                cursor: isExporting ? "not-allowed" : "pointer",
                                width: 30,
                                height: 30,
                                opacity: isExporting ? 0.5 : 1,
                                transition: "opacity 0.2s ease",
                            }}
                            onClick={handleExport}
                        />
                    </Tooltip>

                </Box>
            </Box>
            <Table loading={false} data={data || []} columns={columns} />
        </Paper>
    );
}

const columns = [
    {
        title: "Employee ID",
        key: "employeeId",
    },
    {
        title: "Role",
        key: "role",
    },
    {
        title: "User Name",
        key: "username",
    },

    {
        key: "totalWorkingDays", title: "Working Days",
        // render: (row: any) => {
        //     return row.totalDaysInMonth - row.Holiday - row.HolidayPresent;
        // },
    },
    {
        title: "Holiday",
        key: "Holiday",
    },
    {
        title: "Holiday Present",
        key: "HolidayPresent",
    },
    { key: "Present", title: "Present" },
    { key: "Absent", title: "Absent" },
    {
        title: "Leave",
        key: "Leave",
    },
    {
        title: "Approved Leaves",
        key: "ApprovedLeave",
    },
    {
        title: "Rejected Leave",
        key: "RejectedLeave",
    },
    {
        title: "Blanks",
        key: "NotMention",
    },
];

export default Report;